<section class="customer" id="customer">
  <div class="customer-content">
    <span class="customer-tag">Order in minutes</span>
    <h2>Shop from Your Favourite Local Stores</h2>
    <p>
      Browse nearby restaurants and shops, place your order in a few taps, and track it
      all the way to your door — fresh, fast, and hassle-free.
    </p>

    <ul class="customer-perks">
      <li>Thousands of local stores near you</li>
      <li>Live order tracking</li>
      <li>Secure, easy checkout</li>
    </ul>

    <a class="customer-cta" [href]="customerUrl" target="_blank" rel="noopener">
      Start Shopping
    </a>
  </div>

  <div class="customer-visual">
    <div class="customer-circle"></div>
    <img class="customer-img" src="/images/customer.png" alt="Place your order" />
  </div>
</section>
